import {default as _DNSForm } from "./dnsform";
import { default as _ZoneForm } from "./zoneform";

export const DNSForm = _DNSForm;
export const ZoneForm = _ZoneForm;